import { Box, Typography } from '@mui/material';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import theme from '@shared/themes/darkTheme';

export const LiveButton = ({ isLive, onLiveClick }: { isLive: boolean; onLiveClick: () => void }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          px: 3,
          py: 1.5,
          backgroundColor: isLive ? theme.palette.primary.main : 'transparent',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: `0 4px 15px ${theme.palette.background.boxShadow}`,
          },
        }}
        onClick={onLiveClick}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: 'bold',
            color: isLive ? theme.palette.text.primary : theme.palette.text.secondary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            verticalAlign: 'middle',
          }}
        >
          LIVE
          <LiveTvIcon sx={{ fontSize: '16px', verticalAlign: 'middle', marginBottom: '2%' }} />
        </Typography>
      </Box>
    </Box>
  );
};
